import { ReactNode } from "react";
import { PageTitle } from "./PageTitle";

interface PageBarProps {
    title:     ReactNode;
    children?: ReactNode;
}

export function PageBar({ title, children }: PageBarProps) {
    return <div className="d-flex align-items-center gap-2">
        <PageTitle>
            {title}
        </PageTitle>
        {children}
    </div>;
}
